import { render, staticRenderFns } from "./QuotesList.vue?vue&type=template&id=fe4f3a06&"
import script from "./QuotesList.vue?vue&type=script&lang=js&"
export * from "./QuotesList.vue?vue&type=script&lang=js&"
import style0 from "./QuotesList.vue?vue&type=style&index=0&id=fe4f3a06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports